import { Business } from 'types';

export const formatInstallments = (
  installments = [],
  business: Business,
  shouldDisplayWithDiscountOnAllInstallments = false
): {
  label: string;
  value: string;
}[] => {
  const lastInstallment = installments?.find(
    (_, index) => index === installments?.length - 1
  );

  const lastInstallmentTotalValue =
    Number(lastInstallment.value) * Number(lastInstallment.id);

  return installments?.map((item, index) => {
    const installment = item.id?.toString() || item?.number?.toString();
    const hasDiscount = item.tax && Number(item.tax) < 0;
    const hasIncreasement = item.tax && Number(item.tax) > 0;

    const currentInstallmentTotalValue =
      Number(item.value) * Number(installment);

    const discount = lastInstallmentTotalValue - currentInstallmentTotalValue;

    const isLastInstallment = index === installments.length - 1;

    const displayWithDiscount =
      !isLastInstallment &&
      shouldDisplayWithDiscountOnAllInstallments &&
      discount > 0;

    let suffix = '';
    if (hasDiscount || displayWithDiscount) {
      suffix = '- com desconto';
    }
    if (hasIncreasement && business !== Business.MEDCOF) {
      suffix = '*';
    }

    return {
      value: installment,
      label: `${installment}x de R$ ${item?.value
        ?.toString()
        .replace('.', ',')} ${suffix}`,
    };
  });
};
